<template>
    <div class="devices-list__block" v-if="deviceData" @click="openHeatingHistory">
        <device-status :device="deviceData" :showLocation="showLocation"/>
        <v-layout row class="devices-list__block__title">
            <device-title :device="deviceData"></device-title>
            <v-flex class="btn-block" v-if="deviceData.state">
                <div class="d-inline-flex" v-if="!!deviceData.state.heating">
                    <v-img max-height="30px" max-width="30px" :src="require('@/assets/icons/flame_icon.svg')" class="d-inline-flex"/>
                </div>
                <div class="d-inline-flex" v-else>
                    <v-img max-height="30px" max-width="30px" :src="require('@/assets/icons/flame_disabled_icon.svg')" class="d-inline-flex"/>
                </div>
                <device-favorite :device="deviceData"></device-favorite>
            </v-flex>
        </v-layout>
        <div class="main-text ma-1" v-if="deviceData.state && deviceData.state.current_value && deviceData.online">
            Текущая температура: {{ (deviceData.state.current_value).toFixed(1)}}°C
        </div>
        <div v-if="deviceData.online" class="main-text mt-3 mx-2" @click.stop.prevent>
            <vue-slider
                v-model="deviceData.state.value"
                :data="values"
                :marks="tickLabels"
                :adsorb="true"
                :interval="1"
                :min="16"
                :max="28"
                :height="16"
                :lazy="true"
                :disabled="deviceData.disabled"
                tooltip="none"
                class="vue-custom-slider"
                @change="changeDeviceSlider"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: "HeatingDevice",
    props: {
        device: {
            type: [Array, Object],
            default: null,
        },
        showLocation: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceData: { state: null },
            deviceState: false,
            deviceStateOldValue: null,
            tickLabels: ['OFF', 18, 20, 22, 24, 26, 28],
            values: [16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28,],
            loading: false,
            scrollPrev: 0,
            scrollNext: 0,
            scrollTimeout: null,
            sliderTimeout: null,
        };
    },
    created() {
        this.deviceData = this.device;
        this.deviceState = this.deviceData.state.value ? true : false;
        this.deviceStateOldValue = JSON.parse(JSON.stringify(this.deviceData.state));
    },
    beforeDestroy() {
        if (this.scrollTimeout) {
            clearTimeout(this.scrollTimeout);
        }
        if (this.sliderTimeout) {
            clearTimeout(this.sliderTimeout);
        }
    },
    computed: {
        isScrolled() {
            return this.$store.state.scrolled;
        },
        readonly() {
            return this.scrollPrev == this.scrollNext;
        },
    },
    watch: {
        device: {
            handler: function(val) {
                if (val) {
                    this.deviceData = val;
                    this.loading = false;
                    this.deviceState = this.deviceData.state.value ? true : false;
                    this.deviceData.disabled = false;
                }
            },
            deep: true,
        },
        isScrolled(val) {
            this.scrollNext = val;
            this.checkScroll();
        },
        "deviceData.state": {
            handler: function(val, old) {
                if (val != old && this.deviceData.state.value != this.deviceStateOldValue.value) {
                    this.deviceStateOldValue = old;
                }
            },
            deep: true,
        },
    },
    methods: {
        checkScroll() {
            if (this.scrollPrev != this.scrollNext) {
                if (this.scrollTimeout) {
                    clearTimeout(this.scrollTimeout);
                }
                this.scrollTimeout = setTimeout(() => {
                    this.scrollPrev = this.scrollNext;
                }, 800);
            }
        },
        changeDeviceSwitch() {
            if (this.deviceState) {
                this.deviceData.state.value = 28;
            } else {
                this.deviceData.state.value = 17;
            }
            this.changeDeviceValue();
        },
        changeDeviceSlider() {
            if (this.sliderTimeout) {
                clearTimeout(this.sliderTimeout);
            }
            this.sliderTimeout = setTimeout(() => {
                this.changeDeviceValue();
            }, 1000);
        },
        changeDeviceValue() {
            this.loading = true;
            this.deviceData.disabled = true;
            this.$http.put('/devices/guest/device/' + this.deviceData.uid + '/state', {
                value: this.deviceData.state.value > 17 ? this.deviceData.state.value : null
            })
                .catch((error) => {
                    this.deviceData.state = this.deviceStateOldValue;
                })
                .finally(() => {
                    this.deviceData.disabled = false;
                    this.loading = false;
                });
        },
        openHeatingHistory() {
            if (this.deviceData) {
                this.$router.push({ name: 'heatinghistory', params: {id: this.deviceData.uid} });
            }
        },
    },
}
</script>
